import { paymentActions, PaymentState } from './../../store/payments.era';
import { Account } from 'globals/store/accounts.data';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { environment } from "../../../environments/environment";
import { SubscriptionPlanIds, Promocode } from 'globals/store/accounts.data';
import { countries } from '../../services/countries';
import { Wrapper } from '../wrapper.component';
import { uiActions } from 'src/app/store/ui.era';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: true,
    imports: [CommonModule, MatInputModule, MatFormFieldModule, MatButtonModule, MatDialogModule, IconComponent, MatSelectModule, MatButtonToggleModule, FormsModule, MatProgressSpinnerModule, MatProgressBarModule, MatCheckboxModule],
})
export class PaymentComponent extends Wrapper<PaymentComponent> implements OnInit {

  @Input() area: string;
  @Input() accountId: string;
  @Output() close:EventEmitter<boolean> = new EventEmitter();
  readonly api = `${environment.functionsURL}api/app`;
  readonly webhook = `${environment.functionsURL}api`;
  readonly _file = 'payment.component.ts'
  error_message = '';
  interval_labels = {normal:'Your ',standard:'Standard ',day:'daily subscription',month:'monthly subscription:',year:'yearly subscription'}
  intervally = {day:'daily',month:'monthly',year:'annually'}
  checkout;
  lineitems = [];
  sublineitems = [];
  promo_error = '';
  promocode = '';
  invalid_promocode = '';
  promocode_obj:Promocode;
  docket;
  cardName;
  cc_info_complete;
  invoiceName;
  company = '';
  have_read_terms;
  one_off = true;
  is_loading = false;
  transaction_complete = false;
  selected_plan:SubscriptionPlanIds;
  selected_total:number;
  selected_quantity_idx:number;
  selected_interval = 'month';
  selected_currency:string;
  current_currency:string;
  current_country:string;
  current_quantity_idx:number;
  current_interval = 'month';
  current_plan:SubscriptionPlanIds;
  current_plan_unsupported:Boolean;
  linked_tier:number;
  link_info:any;
  currency_set_by_user:Boolean;
  interval_set_by_user = true;
  next_payment_due;
  next_quantity;
  display_country:string;
  show_current_methods:boolean;
  existing_subscription_id:String;
  ineligible_message_should_show:number;
  needs_more_active_events:boolean;
  contact_us = {name:'', email:'', phone:''};
  contact_us_submitted:boolean;
  proration_date
  proration;
  upcoming_invoice;
  upcoming_invoice_loading;
  available_countries = countries;
  summary = {day:{cost:null,stripePlanId:null},month:{cost:null,stripePlanId:null},year:{cost:null,stripePlanId:null,monthly_cost:null},interval:'month',limit:null,currency:null}
  subscription_picked = false;
  card;
  stripe;
  payment_token;
  active_method_index;

  paymentState: PaymentState
  account: Account

  invoice;
  @ViewChild('paymentForm') paymentForm;
  @ViewChild('promoInput') promoInput;
  @ViewChild('errorElement') errorElement;

  async ngOnInit(){
    // await this.checkForDocket() // <== this nor the next DID anything
    // await this.checkForState()
    
    this.subProp(this.store.select('payment'), 'paymentState')
    const account = await this.take1(this.store.select('accounts','entities',this.accountId))

    this.account = { ...account as Account } 
    this.docket = this.account.docket;
    // set currency
    if(this.account.currency){
      this.selected_currency = this.account.currency;
    }
    // set country

    const settings = await this.take1(this.store.select('settings','user'))
    this.current_country = this.account.country
        ? this.account.country
        : settings.country
    if (settings.currency){
      this.selected_currency = settings.currency;
    }
    this.setDisplayCountry()
    // if settings exist in docket override the defaults
    if(this.docket.stripePlanId){
      const stripePlanId = this.docket.stripePlanId
      const real_quantity = this.docket.limit ;
      this.current_quantity_idx = this.accountService.plans.quantities.findIndex(q => q===real_quantity);
      this.current_plan = {
        quantity:real_quantity,
        stripePlanId:stripePlanId
      };
      const bits = stripePlanId.split('_');
      this.current_interval = bits[2];
      this.current_currency = this.selected_currency = bits[1];
      this.selected_interval = this.current_interval;
      if(this.accountService.plans.plan_prefix !== bits[0]){
        this.current_plan_unsupported = true;
      }
      if(this.docket.useGst){ this.current_country = 'AU'}
      this.selected_quantity_idx = this.current_quantity_idx;
      this.interval_set_by_user = true;
    }else{
      // if settings do not exist in docket, choose the lowest quantity they need
      this.accountService.plans.quantities.forEach((quantity,idx)=>{
        if(this.selected_quantity_idx !== undefined) return;
        if(!this.docket.tally || this.docket.tally <= quantity){
          this.selected_quantity_idx = idx;
        }
      })
      // console.log('this.accountService.plans.intervals ', this.accountService.plans.intervals);
      if(this.accountService.plans.intervals.length === 1 && !this.selected_interval){
        this.selected_interval = this.accountService.plans.intervals[0];
      }
    }
    // for future linked accounts functionality, populate linked variables => Seems to have never been implemented as this was never set 
/*     if(this.accountService.account_link_info[this.docket.linked]){
      this.link_info = {
        accounts:[...this.accountService.account_link_info[this.docket.linked].accounts],
        tiers:[...this.accountService.account_link_info[this.docket.linked].tiers],
        tier:this.accountService.account_link_info[this.docket.linked].tier,
        sum:0
      }
      this.link_info.sum = this.link_info.tiers.reduce((t,n)=>t+n);
      this.linked_tier = this.link_info.tier;
    } */

    // setup cc form details
    this.cardName = this.docket.cardName || this.userService.firstName + ' ' +this.userService.lastName;
    this.invoiceName = this.docket.invoiceName || this.account.title;
    // this.company = this.user.company;

    // set active payment method to docket method and assume they dont need the cc form
    if(this.docket.active_method_index >= 0 && this.docket.methods.length > 0){
      this.show_current_methods = true;
      this.active_method_index = this.docket.active_method_index;
    }
    if(this.docket.stripeSubscriptionId){
      this.existing_subscription_id = this.docket.stripeSubscriptionId;
    }

    this.resetBtns() // make buttons set to default
    if(!this.area) {
        this.one_off = false;
        this.area = 'subscription';
    }else if(this.area === 'method'){
      this.cc_info_complete = true;
      this.show_current_methods = false;
      this.cc_info_complete = false;
      this.resetBtns(['cancel','cta'])
    }

    // contact_us is unused at the moment. Users are sent to the joi website - contact us page
    this.contact_us.name = this.userService.firstName + " " + this.userService.lastName;
    this.contact_us.email = this.userService.email;

    setTimeout(_=>{ // connect to stripe
       this.setupAddPaymentSource();
    },0)

    // build out summary using the selected options
    this.updatePriceDetails();
    if(!this.current_plan) this.current_plan = {quantity:null, stripePlanId:null};

    if (this.paymentForm)
      this.paymentForm.nativeElement.addEventListener('submit', this.onSubmit);
    this.accountService.account_in_payment_process = {} // This is reset here because the webhook can't reset it. The idea being they won't see the error again after they pay
  }
  emitClose(complete?){
    this.store.dispatch(paymentActions.updateState({header_title:'Joi Subscription', header_class:''}))
    this.close.emit(complete)
  }
  setDisplayCountry(){
    const country_index = countries.findIndex(c => c.code === this.current_country)
    this.display_country = countries[country_index].name;
    if(!this.currency_set_by_user){
      this.selected_currency = countries[country_index].currency || "USD";
      this.updatePriceDetails()
    }
  }
  // contact_us is unused at the moment. Users are sent to the joi website - contact us page
  submitContactUs(){
    // console.log('contact_us ', this.contact_us);
    this.area = 'request_sent';
    this.resetBtns(['close']);
    this.contact_us_submitted = true;
  }
  openContactUsURL(){
    window.open('https://www.joi.events/contact','_blank')
  }
  proceed(){
    // console.log('this.area ', this.area);
    switch (this.area){
      case 'subscription':
        this.store.dispatch(paymentActions.updateState({header_title:'Joi Subscription', header_class:''}))
        this.calcLineItemsAndTotal();
        this.area = 'summary';
        this.resetBtns(['prev','cancel','next'])
        if(this.existing_subscription_id ){
          if(this.current_quantity_idx < this.selected_quantity_idx){
            this.upcoming_invoice = null;
            this.upcoming_invoice_loading = false;
            this.area = 'upcoming';
            this.getUpcoming();
          }else if(this.current_quantity_idx > this.selected_quantity_idx){
            this.area = 'downgrade'
            this.resetBtns(['prev','cancel','update'])
          }
        }
        break;
      case 'cancel':
        this.area = "cancel_complete";
        this.resetBtns(['close'])
        break;
      case 'downgrade':
      case 'method':
        this.area = this.one_off ? "method_complete" : "complete";
        this.resetBtns(['close'])
        break;
      default: // case 'storage':
          this.area = 'method';
          this.resetBtns(['prev','cancel','cta'])
          break;
    }
    this.one_off = false;
  }
  previous() {
    if(this.paymentState.show_promo_input && this.promocode !== '' && !this.promocode_obj) {
      this.promocode = '';
      this.store.dispatch(paymentActions.updateStateItem('show_promo_input', false))
    }
    switch(this.area){
      case 'subscription':
        break;
      case 'summary':
      case 'downgrade':
      case 'cancel':
      case 'unable-to-cancel':
      case 'upcoming':
        this.area = 'subscription';
        this.resetBtns(['cancel','next'])
        this.one_off = true;
        this.store.dispatch(paymentActions.updateState({header_title:'Joi Subscription', header_class:''}))
        break;
      case 'method':
        this.promocode = '';
        this.promo_error = '';
        this.store.dispatch(paymentActions.updateStateItem('show_promo_input',false))
        this.area = 'summary';
        this.resetBtns(['prev','cancel','next'])
        break;
    }
  }

  resetBtns(array_of_true_values?){
    // console.log('array_of_true_values ', array_of_true_values);
    this.store.dispatch(paymentActions.setButtons(array_of_true_values));
  }
  // load upcoming invoices
  getUpcoming(){
    this.is_loading = true;
    this.upcoming_invoice_loading = true;
    this.proration_date = Math.floor(Date.now() / 1000);
    const stripeId = this.docket.stripeId;
    const stripeSubscriptionId = this.docket.stripeSubscriptionId;
    const url = `${this.api}/predict-upcoming`;
    const invoice_changes = {
      accountId:this.accountId,
      plan:this.selected_plan,
      subscriptionId:stripeSubscriptionId,
      proration_date:this.proration_date,
      prorate:false,
      end_current:true,
      stripeId
    }
    if(this.promocode_obj){
      invoice_changes['promocode'] = this.promocode_obj.code;
    }
    this.take1(this.http.post(url, invoice_changes)).then((data:any) =>{
      const invoice = data.invoice;
      this.upcoming_invoice = invoice;
      this.calcLineItemsAndTotal();
      this.is_loading = false;
    },response=>{
      this.logService.error({
        file:this._file,
        function:'getUpcoming http.post',
        response,
        error:new Error(),
        message:'There was an error predicting your calculated proration summary'
      })
      this.is_loading = false;
      this.upcoming_invoice_loading = false;
    })
  }
  calcLineItemsAndTotal(){
    // ('selected_plan', this.selected_plan);
    let total = 0;
    this.lineitems = [];
    this.sublineitems = [];
    let gst
    const bits = this.selected_plan.stripePlanId.split('_');
    const int = this.interval_labels[this.selected_interval];
    const limit = this.summary.limit + ' Events';
    const line = this.interval_labels['normal'] + ' ' + int + ' ' + limit;
    if(this.upcoming_invoice){
      const invoice = this.upcoming_invoice;
      this.upcoming_invoice_loading = false;
      // console.log('invoice ', invoice);
      const current_prorations = [];
      const cost = 0;
      let non_proration_amount = 0;
      for (let i = 0; i < invoice.lines.data.length; i++) {
        const invoice_item = invoice.lines.data[i];
        current_prorations.push(invoice_item);
        this.lineitems.push({type:'proration',line:invoice_item.description,item:invoice_item.amount/100});
        if(!invoice_item.proration) non_proration_amount += invoice_item.amount;
      }
      if(invoice.discount){
        this.sublineitems.push({type:'subtitle',line:'Subtotal: ', item:invoice.subtotal / 100});
        // console.log('non_proration_amount ', non_proration_amount);
        const discount_item = invoice.discount.coupon.percent_off
          ? non_proration_amount * (invoice.discount.coupon.percent_off / 100)
          : non_proration_amount - invoice.discount.coupon.amount_off / 100;
        // console.log('discount_item ', discount_item);
        this.sublineitems.push({type:'promo',line:'Code: ',code:invoice.discount.coupon.id, code_name:" ("+invoice.discount.coupon.name+")", item:discount_item / -100, object:invoice.discount / 100})
      }
      total = invoice.total / 100;
      gst = invoice.tax / 100;
    }else{
      gst = this.summary[this.selected_interval].cost/11;
      const item = this.summary[this.selected_interval].cost;
      this.lineitems.push({type:'plan', line, item});
      total += item;
      if(this.promocode_obj){
        this.sublineitems.push({type:'subtitle',line:'Subtotal: ', item:total});
        const discount_item = this.promocode_obj.percent_off
          ? total * (this.promocode_obj.percent_off / 100)
          : total - this.promocode_obj.amount_off / 100;
        this.sublineitems.push({type:'promo',line:'Code: ',code:this.promocode_obj.code, code_name:" ("+this.promocode_obj.name+")", item:discount_item});
        if(this.promocode_obj.amount_off){ // untested
          const pre_promo_total = total;
          total -= this.promocode_obj.amount_off;
          // find percent that was taken off from price and remove that percent from the gst
          const percent = total/pre_promo_total;
          gst = gst - gst * percent;
          if(total < 0) total = 0;
        }
        if(this.promocode_obj.percent_off){
          total = total - total * (this.promocode_obj.percent_off/100);
          gst = gst - gst * (this.promocode_obj.percent_off/100);
          if(total < 0) total = 0;
        }
      }
    }
    if(this.current_country === 'AU'){
      this.sublineitems.push({type:'gst',line:'GST – AU (10% inclusive)', item:gst});
    }
    this.selected_total = total;
  }
  displayPromoCodeInput(){
    this.store.dispatch(paymentActions.updateStateItem('show_promo_input',true))
    setTimeout(_ => { this.promoInput.nativeElement.focus() })
  }
  removePromoAppliedCode(){
    this.promo_error = '';
    this.invalid_promocode = '';
    this.promocode_obj = null;
    this.promocode = '';
    if(this.upcoming_invoice){
      this.getUpcoming();
    }else{
      this.calcLineItemsAndTotal();
    }
  }
  applyPromoCode(){
    this.is_loading = true;
    this.promo_error = '';
    this.invalid_promocode = this.promocode;
    const url = `${this.api}/validate-promo`;
    this.take1(this.http.post(url, {promocode:this.promocode, accountId:this.accountId, plan:this.selected_plan})).then(rtn =>{
      if(rtn){
        this.promocode_obj = rtn as Promocode;
        // console.log('this.promocode_obj ', this.promocode_obj);
        this.promocode = '';
        this.invalid_promocode = '';
        if(this.upcoming_invoice){
          this.getUpcoming();
        }else{
          this.calcLineItemsAndTotal();
        }
      }else{
        this.promo_error = 'Promocode not found';
      }
      this.is_loading = false;
      this.store.dispatch(paymentActions.updateStateItem('show_promo_input',false))
    }, err => {
      this.is_loading = false;
      this.promo_error = 'Promocode not found';
    })
  }
  // onInterval click
  updateInterval(interval){
    this.selected_interval = interval;
    this.interval_set_by_user = true;
    this.updatePriceDetails();
  }
  // build out summary using the selected options
  updatePriceDetails(){
    this.upcoming_invoice = null;
    this.needs_more_active_events = false;
    if(this.selected_quantity_idx < 0){
      this.needs_more_active_events = true;
      return;
    }
    if(this.summary.currency !== this.selected_currency || this.summary.limit !== this.accountService.plans.quantities[this.selected_quantity_idx]){
      const limit = this.accountService.plans.quantities[this.selected_quantity_idx];
      let standard_daily_id;
      let standard_monthly_id;
      let standard_yearly_id;
      if(this.linked_tier){
        // work out proposed new tier
        // find current account id idx
        const index = this.link_info.accounts.indexOf(this.accountId)
        // change tiers costing
        // console.log('tiers ',this.link_info.tiers[index]);
        this.link_info.tiers[index] = limit;
        // add
        let cumm_tier = 0;
        this.link_info.tiers.forEach(tier=>{
          cumm_tier += tier;
        })
        this.link_info.sum = cumm_tier;
        // console.log('cumm_tier ', cumm_tier);
        // get closest tier
        // console.log(this.accountService.plans)
        let new_tier = 0;
        this.accountService.plans.quantities.forEach(q => { if(cumm_tier >= q) new_tier = q; })
        // console.log('this.linked_tier ', this.linked_tier);
        // console.log('new_tier ', new_tier);
        this.linked_tier = new_tier;
      }
      const linked_tier = this.linked_tier ? this.linked_tier : limit;
      const daily_id = this.selected_currency + '_day_' + linked_tier
      const monthly_id = this.selected_currency + '_month_' + linked_tier
      const yearly_id = this.selected_currency + '_year_' + linked_tier
      standard_daily_id = daily_id;
      standard_monthly_id = monthly_id;
      standard_yearly_id = yearly_id;
      if(this.linked_tier){
        standard_daily_id = this.selected_currency + '_day_' + limit;
        standard_monthly_id = this.selected_currency + '_month_' + limit
        standard_yearly_id = this.selected_currency + '_year_' + limit
      }
      const summary = {
        currency:this.selected_currency,
        interval : this.selected_interval,
        limit,
        day:{
          stripePlanId : this.accountService.plans.plan_prefix + '_' + daily_id,
          cost: this.accountService.plans.costings[daily_id] * limit,
          monthly_cost:this.accountService.plans.costings[daily_id] * limit * 365 / 12,
          standard_monthly_cost: this.accountService.plans.costings[standard_daily_id] * limit * 365 / 12,
          standard_monthly_savings: null
        },
        month:{
          stripePlanId : this.accountService.plans.plan_prefix + '_' + monthly_id,
          cost: this.accountService.plans.costings[monthly_id] * limit,
          monthly_cost: this.accountService.plans.costings[monthly_id] * limit,
          standard_monthly_cost: this.accountService.plans.costings[standard_monthly_id] * limit,
          standard_monthly_savings: null
        },
        year:{
          stripePlanId : this.accountService.plans.plan_prefix + '_' + yearly_id,
          cost: this.accountService.plans.costings[yearly_id] * limit,
          monthly_cost:this.accountService.plans.costings[yearly_id] * limit / 12,
          standard_monthly_cost: this.accountService.plans.costings[standard_yearly_id] * limit / 12,
          standard_monthly_savings: null
        }
      };
      summary.day.standard_monthly_savings = summary.day.standard_monthly_cost - summary.day.monthly_cost;
      summary.month.standard_monthly_savings = summary.month.standard_monthly_cost - summary.month.monthly_cost;
      summary.year.standard_monthly_savings = summary.year.standard_monthly_cost - summary.year.monthly_cost;
      this.summary = summary;
      // console.log('summary ', summary);
    }
    if(this.summary.interval && this.summary.limit && this.interval_set_by_user){
      this.selected_plan = {
        quantity:this.summary.limit,
        stripePlanId:this.summary[this.summary.interval].stripePlanId
      }
    }
  }
  // onClick of quantity too small for account's current event load
  showIneligibleMessage(should_show, quantity){
    // console.log('showIneligibleMessage');
    this.ineligible_message_should_show = should_show ? quantity : 0;
    this.updatePriceDetails();
  }
  updateCountry(){
    // this.store.dispatch(new UpdateUserSetting('country',this.current_country))
    this.settingsService.saveUserSetting('country',this.current_country);
    this.setDisplayCountry();
  }
  updateCurrency(){
    this.selected_plan = null;
    // this.store.dispatch(new UpdateUserSetting('currency',this.selected_currency))
    this.settingsService.saveUserSetting('currency',this.selected_currency);
    this.currency_set_by_user = true;
    this.updatePriceDetails();
  }
  swapActiveMethod(index, evt){
    // if(evt.target.nodeName === 'ICON'){
    //   console.log('have some kind of edit mode')
    // }
    this.active_method_index = index;
  }
  toggleShowMethods(){
    this.show_current_methods = !this.show_current_methods;
  }
  termsClick(evt){
    if(evt.target.nodeName === 'SPAN') return this.openTerms();
    this.have_read_terms = !this.have_read_terms;
  }
  openTerms(){
    window.open("https://www.joi.events/eula", "_blank");
  }
  // setup stripe
  setupAddPaymentSource(){
    this.stripe = window['Stripe'](environment.stripePubKey);
    const elements = this.stripe.elements();
    const style = {
      base: {
        // Add your base input styles here. For example:
        fontSize: '16px',
        color: "#333",
      },
      invalid: {
        color: "#F05453"
      }
    };

    // Create an instance of the card Element.
    this.card = elements.create('card', {style});

    // Add an instance of the card Element into the `card-element` <div>.
    this.card.mount('#card-element');

    this.card.addEventListener('change', (info) => {
      // console.log('info ', info);
      const error = info.error;
      this.cc_info_complete = info.complete;
      const displayError = document.getElementById('card-errors');
      if (error) {
        displayError.textContent = error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  confirmCancelSubscription(){
    this.store.dispatch(paymentActions.updateState({
      header_title: !this.docket.tally ? 'Cancel Subscription' : 'Oops!',
      header_class:'warn_header'
    }))
    this.area = !this.docket.tally ? 'cancel' : 'unable-to-cancel'
    const btns = !this.docket.tally || this.docket.tally === 0 ? ['dont','cancel','remove'] : []
    this.resetBtns(btns)
    this.one_off = false;
  }

  async cancelSubscription(){
    const url = `${this.api}/stripe-cancel-subscription`;
    this.is_loading = true;
    const data = await this.take1(this.http.post(url, {accountId:this.accountId})) // there never was any real error handling here
    this.is_loading = false;
      // console.log('data ',data)
    if(data['status'] === "canceled"){
      this.proceed();
    }else{
      this.logService.error({
        file:this._file,
        function:'cancelSubscription http.post',
        response:data,
        data:{accountId: this.accountId},
        level:10,
        error:new Error(),
        message:'There was a system error that stopped your subscription from being cancelled properly. We will be looking into this issue.'
      })
      this.is_loading = false;
    }
  }

  save() {
    this.errorElement.nativeElement.textContent = '';
    if(!this.have_read_terms && this.area !== 'downgrade') return; // todo: add error indication
    this.accountService.account_in_payment_process[this.accountId] = true;
    this.is_loading = true;
    const self = this;

    const ownerInfo = {
      currency:this.selected_currency,
      owner: {
        name: this.cardName,
        email: this.userService.email
      }
    }
    if(this.show_current_methods
      && !this.one_off
      && this.active_method_index >= 0
      && this.docket.methods[this.active_method_index]
    ){
      const source = this.docket.methods[this.active_method_index];
      this.stripeCreateSubscription(source);
      return;
    }
    this.stripe.createSource(this.card, ownerInfo).then(function(result) {
      // Handle result.error or result.token
      if(result.source){
        if(self.one_off){
          self.stripeSaveSource(result.source)
        }else{
          self.stripeCreateSubscription(result.source);
        }
      }else{
        const error = result.error || {message:'Unknown error'};
        self.errorElement.nativeElement.textContent = error.message;
        self.logService.error({
          file:self._file,
          function:'stripe.createSource',
          response:result,
          error:new Error()
        })
        self.is_loading = false;
      }
    });
  }
  stripeCreateSubscription(source){
    const url = `${this.api}/stripe-handle-subscription`;
    const process_obj = {
      action:'create-subscription',
      source,
      useGst:this.current_country === 'AU',
      promocode:this.promocode_obj ? this.promocode_obj.code : null,
      accountId:this.accountId,
      plan:this.selected_plan,
      invoiceName:this.invoiceName,
      cardName:this.cardName
    }
    if(this.existing_subscription_id){
      process_obj.action = 'update-subscription'
    }
    this.take1(this.http.post(url, process_obj)).then(data =>{
      if(data && data['subscription']){
        if(data['subscription'].status === 'active'){
          this.subscriptionSuccess(data);
        }else if(data['subscription'].status === 'open'){ // pending
          this.subscriptionInProgress(data);
        }else{
          this.subscriptionFailed(data);
        }
        this.accountService.saveCountry(this.accountId, this.current_country, this.selected_currency)
      }
      if(data && data['message']){
        this.errorElement.nativeElement.textContent = data['message'];
        this.logService.error({
          file:this._file,
          function:'http.post /stripe-handle-subscription',
          response:data,
          data:{process_obj},
          error:new Error()
        })
        this.is_loading = false;
      }
      if(!data){
        // todo: make better
        this.store.dispatch(uiActions.addUIMessage({
          type:'error',
          action:'standard',
          message:'An unknown error has occured.'
        }))
        // this.log.$events.next({type:'error',action:'standard',data:{message:'An unknown error has occured.'}})
      }
      this.is_loading = false;
    },response=>{
      this.logService.error({
        file:this._file,
        function:'stripeSourceHandler http.post',
        response,
        error:new Error(),
        message:'There was a system error that stopped your payment for working properly'
      })
      this.is_loading = false;
    })
  }
  onSubmit(evt){
    evt.preventDefault()
    return false;
  }
  stripeSaveSource(source){
    const url = `${this.api}/stripe-handle-source`;
    const process_obj = {
      action:'create-source',
      source,
      accountId:this.accountId,
    }
    this.take1(this.http.post(url, process_obj)).then(data => {
      if(data) this.sourceSuccess(data);
      else {
        this.logService.error({
          file:this._file,
          function:'stripeSaveSource http.post',
          response:data,
          error:new Error(),
          message:'There was an issue with the card details you entered.'
        })
        this.is_loading = false;
      }
    },response=>{
      this.logService.error({
        file:this._file,
        function:'stripeSaveSource http.post',
        response,
        error:new Error(),
        message:'There was a system error that stopped your card from being updated properly'
      })
      this.is_loading = false;
    })
  }

  subscriptionSuccess(data){
    this.invoice = data;
    this.transaction_complete = true;
    this.is_loading = false;
    this.next_payment_due = data.subscription.current_period_end * 1000; // add the milliseconds
    if(data.lines && data.lines.data && data.lines.data.length){
      data.lines.data.forEach(line=>{
        if(!line.proration){
          this.next_quantity = line.quantity;
        }
      })
    }
    if(this.area === 'downgrade'){
      this.next_quantity = this.accountService.plans.quantities[this.selected_quantity_idx];
    }
    this.proceed();
    // console.log(' subscriptionSuccess ')
  }

  sourceSuccess(data){
    this.invoice = data;
    this.transaction_complete = true;
    this.next_payment_due = data.subscriptions.data[0].current_period_end * 1000; // add the milliseconds
    this.is_loading = false;
    this.proceed();
    // console.log(' sourceSuccess ')
  }

  subscriptionFailed(data){
    this.is_loading = false;
    // there was a problem proccessing you payment goes in the payment error error messages
    // change webhook to update docket.payment_error_message and display that
    // update docket.payment_error_message on success
  }

  cancellationSuccess(data){
    this.invoice = data;
    this.transaction_complete = true;
    this.is_loading = false;
    this.proceed();
    // console.log(' cancellationSuccess ')
  }

  subscriptionInProgress(data){
    this.proceed();
  }

}
